<template>
  <div>
    <h2>
      {{
        t('thanksForReturn', {
          firstName: user?.firstName,
        })
      }}
    </h2>
    <p class="mt-4">
      {{ t('returnSuccess', { bookingNumber: booking?.bookingNumber }) }}
    </p>
    <BigSuccess />

    <Divider />
    <div class="flex justify-end gap-4">
      <CVButton variant="secondary" :to="{ name: 'bookingEdit', params: { id: route.params.id } }">
        {{ t('showBooking') }}
      </CVButton>
      <CVButton :to="{ name: 'upcomingHandovers' }">
        {{ t('next') }}
      </CVButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import BigSuccess from '@/components/BigSuccess.vue';
import Divider from '@/components/Divider.vue';
import { useMe } from '@/queries/use-users';
import { useI18n } from 'vue-i18n';
import { useBooking } from '@/queries/use-bookings';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const { data: user } = useMe();
const route = useRoute();
const { data: booking } = useBooking(route.params.id as string);
</script>

<i18n lang="json">
{
  "en": {
    "next": "Back to Dashboard",
    "showBooking": "Show Booking",
    "thanksForReturn": "Thanks {firstName} for your good work!",
    "returnSuccess": "Booking {bookingNumber} is successfully completed and the vehicle can now be cleaned again."
  },
  "de": {
    "next": "Zurück zur Übersicht",
    "showBooking": "Buchung anzeigen",
    "thanksForReturn": "Danke {firstName} für deine Gute Arbeit!",
    "returnSuccess": "Buchung {bookingNumber} wurde erfolgreich abgeschlossen und das Fahrzeug kann jetzt wieder aufbereitet werden."
  },
  "es": {
    "next": "Volver a la vista general",
    "showBooking": "Ver reserva",
    "thanksForReturn": "¡Gracias, {firstName}, por tu buen trabajo!",
    "returnSuccess": "La reserva {bookingNumber} se ha completado correctamente y el vehículo ya puede volver a prepararse."
  }
}
</i18n>
